import { useEffect } from 'react';

// Beobachter fuer Scroll-Enthuellung und aktive Menue-Hervorhebung.
// Frueher im Inline-Skript von index.html mit einem MutationObserver auf #root (subtree),
// der bei JEDER DOM-Aenderung erneut querySelectorAll ausfuehrte. Hier laeuft die
// Registrierung genau einmal nach dem Mounten -- alle beobachteten Abschnitte (#skills,
// #projects, #downloads aus React, #home/#contacts aus index.html) existieren dann bereits.

const ABSCHNITT_IDS = ['home', 'skills', 'projects', 'downloads', 'contacts'];

// Browser mit scroll-driven animations erledigen die Enthuellung rein per CSS
// (siehe index.css) -- dann darf der IntersectionObserver-Weg nicht parallel laufen.
const hatScrollZeitleiste = () =>
  typeof CSS !== 'undefined' && CSS.supports('(animation-timeline: view()) and (animation-range: entry)');

export function useSeitenBeobachter() {
  useEffect(() => {
    const beobachter = [];

    // Scroll-Enthuellung (nur Fallback-Browser)
    if (!hatScrollZeitleiste()) {
      const enthuellung = new IntersectionObserver(
        (eintraege) => {
          eintraege.forEach((eintrag) => {
            if (eintrag.isIntersecting) {
              eintrag.target.classList.add('istSichtbar');
              enthuellung.unobserve(eintrag.target);
            }
          });
        },
        // threshold 0 statt eines Anteils: die Abschnitte sind teils mehrere Bildschirme
        // hoch, ein Anteil von 12 % waere erst nach fast einer ganzen Viewport-Hoehe erreicht.
        { threshold: 0, rootMargin: '0px 0px -10% 0px' }
      );
      document.querySelectorAll('.scrollEnthuellung').forEach((el) => enthuellung.observe(el));
      beobachter.push(enthuellung);
    }

    // ScrollSpy zur aktiven Menue-Hervorhebung
    const navigationsLinks = document.querySelectorAll('.nav-link');
    const bereichsBeobachter = new IntersectionObserver(
      (eintraege) => {
        eintraege.forEach((eintrag) => {
          if (!eintrag.isIntersecting) return;
          navigationsLinks.forEach((link) => {
            link.classList.toggle('active', link.getAttribute('href').substring(1) === eintrag.target.id);
          });
        });
      },
      { root: null, rootMargin: '-20% 0px -70% 0px', threshold: 0 }
    );
    ABSCHNITT_IDS.forEach((id) => {
      const bereich = document.getElementById(id);
      if (bereich) bereichsBeobachter.observe(bereich);
    });
    beobachter.push(bereichsBeobachter);

    if (window.scrollY === 0) {
      document.querySelector('a[href="#home"]')?.classList.add('active');
    }

    return () => beobachter.forEach((b) => b.disconnect());
  }, []);
}
